module.exports = __webpack_public_path__ + "static/media/useful1.7aca90d1.png";